import { useEffect, useRef } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

export function SiteMap({ center, radius, points = [] }) {
  const elRef = useRef(null);
  const mapRef = useRef(null);

  useEffect(() => {
    if (!elRef.current || mapRef.current) return;
    const map = L.map(elRef.current, { scrollWheelZoom: false });
    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution: "© OpenStreetMap", maxZoom: 19,
    }).addTo(map);
    mapRef.current = map;

    const bounds = [];
    if (center) {
      L.circleMarker(center, { radius: 8, color: "#0A192F", weight: 2, fillColor: "#0891b2", fillOpacity: 1 })
        .addTo(map).bindPopup("Baustelle");
      if (radius) {
        L.circle(center, { radius, color: "#0891b2", weight: 1, fillColor: "#0891b2", fillOpacity: 0.08 }).addTo(map);
      }
      bounds.push(center);
    }
    points.forEach((p) => {
      const c = p.flagged ? "#dc2626" : "#16a34a";
      L.circleMarker([p.lat, p.lng], { radius: 6, color: c, weight: 2, fillColor: c, fillOpacity: 0.85 })
        .addTo(map)
        .bindPopup(`<b>${p.name || ""}</b><br/>${p.when || ""}${p.flagged ? `<br/><span style="color:#dc2626">⚠ ${p.dist} m entfernt</span>` : ""}`);
      bounds.push([p.lat, p.lng]);
    });

    if (bounds.length === 1) map.setView(bounds[0], 15);
    else if (bounds.length > 1) map.fitBounds(bounds, { padding: [30, 30], maxZoom: 16 });
    else map.setView([51.1657, 10.4515], 5);

    setTimeout(() => map.invalidateSize(), 200);
    return () => { map.remove(); mapRef.current = null; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <div ref={elRef} className="h-[280px] w-full" data-testid="bau-map" />;
}
